// extracted by mini-css-extract-plugin
export default {"textContainer":"_1KpTUG3ZPDqZSR1b8CWhCS","buttonsContainer":"esu_-sK-SexTs-zWCgVdb","noBorderBottom":"_36luBZZaNlKdmBzkUOlgng","previewButton":"_3SphP7J1MHlzZOiUpjWrmZ"};